import classnames from 'consts/classnames';
import scroll from 'utils/scroll';

/**
 * * @returns {void}
 */
const mainMenu = () => {
    const container = document.querySelector('.js-header');

    if (!container) {
        return;
    }

    const { NAV_IS_OPEN, IS_OPEN, IS_ACTIVE } = classnames;
    const BREAKPOINT_LARGE_MIN = 1440;
    const subnavClass = 'js-subnav';
    const subnavItemClass = 'js-subnav-item';
    const subnavListClass = 'js-subnav-list';
    const contentContainerClass = 'wrapper';
    const subnavListContainerClass = 'js-subnav-list-container';
    const navToggler = container.querySelector('.js-nav-toggler');
    const subnavs = container.querySelectorAll(`.${subnavClass}`);
    const subnavComputedStyle = subnavs.length
        ? getComputedStyle(subnavs[0])
        : null;
    const subnavHasPaddingTop =
        subnavComputedStyle && subnavComputedStyle.paddingTop;
    const subnavHasPaddingBottom =
        subnavComputedStyle && subnavComputedStyle.paddingBottom;
    const subnavPaddingTop = subnavHasPaddingTop
        ? Number(subnavComputedStyle.paddingTop.slice(0, -2))
        : 0;
    const subnavPaddingBottom = subnavHasPaddingBottom
        ? Number(subnavComputedStyle.paddingBottom.slice(0, -2))
        : 0;
    const mainMenuLinks = container.querySelectorAll('.js-main-menu-link');
    const subnavLinks = container.querySelectorAll('.js-subnav-link');
    const backSubnavButtons = container.querySelectorAll(
        '.js-subnav-back-button'
    );
    const backSubnavLevelButtons = container.querySelectorAll(
        '.js-subnav-level-back-button'
    );
    const { body } = document;

    // media query
    const largeDeviceQuery = window.matchMedia(
        `(min-width: ${BREAKPOINT_LARGE_MIN}px)`
    );

    let isLargeDeviceQuery = largeDeviceQuery.matches;

    updateIsLargeDeviceQuery();
    clickMenuButton();
    subnavigation();
    removeSubnavHeightOnMouseleave();
    bindClickListenerToMainMenuLinks();
    bindClickListenerToSubnavLinks();
    bindClickListenerToBackSubnavButtons();
    bindClickListenerToBackSubnavLevelButtons();

    /**
     * @param {HTMLElement} element
     * * @returns {boolean}
     */
    function isVisible(element) {
        return element.offsetHeight > 0 && element.offsetWidth > 0;
    }

    /**
     * * @returns {void}
     */
    function updateIsLargeDeviceQuery() {
        largeDeviceQuery.addEventListener('change', event => {
            isLargeDeviceQuery = event.matches;
        });
    }

    /**
     * * @returns {void}
     */
    function clickMenuButton() {
        if (!navToggler) {
            return;
        }

        let menuIsOpen = false;

        navToggler.addEventListener('click', event => {
            const { currentTarget } = event;

            menuIsOpen = !menuIsOpen;

            if (menuIsOpen) {
                body.classList.add(NAV_IS_OPEN);
                scroll.forbid();
                currentTarget.setAttribute('aria-expanded', 'true');
                return;
            }

            body.classList.remove(NAV_IS_OPEN);
            scroll.restore();
            currentTarget.setAttribute('aria-expanded', 'false');

            const visibleSubnav = container.querySelector(
                `.js-subnav.${IS_ACTIVE}`
            );

            if (!visibleSubnav) {
                return;
            }

            const openMenus = visibleSubnav.querySelectorAll(`.${IS_OPEN}`);

            if (openMenus.length) {
                openMenus.forEach(menu => {
                    menu.classList.remove(contentContainerClass);
                    menu.classList.remove(IS_OPEN);
                });
            }

            visibleSubnav.classList.remove(IS_ACTIVE);
        });
    }

    /**
     * * @returns {void}
     */
    function setSubnavHeightAccordingToContent() {
        if (!isLargeDeviceQuery) {
            return;
        }

        const visibleSubnav = [...subnavs].find(nav => isVisible(nav));

        if (!visibleSubnav) {
            return;
        }

        const subnavLists = visibleSubnav.querySelectorAll(
            `.${subnavListClass}`
        );
        const visibleLists = [...subnavLists].filter(item => isVisible(item));

        const visibleSubnavListsHeights = visibleLists.map(
            item => item.clientHeight
        );

        const maxheight = Math.max(...visibleSubnavListsHeights);
        let visibleSubnavHeight = maxheight;

        if (subnavPaddingTop) {
            visibleSubnavHeight += subnavPaddingTop;
        }

        if (subnavPaddingBottom) {
            visibleSubnavHeight += subnavPaddingBottom;
        }

        visibleSubnav.style.height = `${visibleSubnavHeight}px`;
    }

    /**
     * * @returns {void}
     */
    function subnavigation() {
        const subnavItems = container.querySelectorAll(`.${subnavItemClass}`);

        subnavItems.forEach(item => {
            item.addEventListener(
                'mouseenter',
                setSubnavHeightAccordingToContent
            );

            item.addEventListener(
                'mouseleave',
                setSubnavHeightAccordingToContent
            );
        });
    }

    /**
     * * @returns {void}
     */
    function bindClickListenerToMainMenuLinks() {
        if (!mainMenuLinks || !mainMenuLinks.length) {
            return;
        }

        mainMenuLinks.forEach(link => {
            link.addEventListener('click', event => {
                const subnav = link.parentNode.querySelector(`.${subnavClass}`);

                if (subnav && !isLargeDeviceQuery) {
                    event.preventDefault();
                    subnav.classList.add(IS_ACTIVE);
                }
            });
        });
    }

    /**
     * * @returns {void}
     */
    function bindClickListenerToSubnavLinks() {
        if (!subnavLinks || !subnavLinks.length) {
            return;
        }

        subnavLinks.forEach(link => {
            link.addEventListener('click', event => {
                const subnavListContainer = link.parentNode.querySelector(
                    `.${subnavListContainerClass}`
                );

                if (subnavListContainer && !isLargeDeviceQuery) {
                    event.preventDefault();

                    subnavListContainer.classList.add(IS_OPEN);
                    subnavListContainer.classList.add(contentContainerClass);
                }
            });
        });
    }

    /**
     * * @returns {void}
     */
    function bindClickListenerToBackSubnavButtons() {
        if (!backSubnavButtons || !backSubnavButtons.length) {
            return;
        }

        backSubnavButtons.forEach(button => {
            button.addEventListener('click', () => {
                const parentSubnav = button.closest(`.${subnavClass}`);

                if (!parentSubnav) {
                    return;
                }

                parentSubnav.classList.remove(IS_ACTIVE);
            });
        });
    }

    /**
     * * @returns {void}
     */
    function bindClickListenerToBackSubnavLevelButtons() {
        if (!backSubnavLevelButtons || !backSubnavLevelButtons.length) {
            return;
        }

        backSubnavLevelButtons.forEach(button => {
            button.addEventListener('click', () => {
                const subnavListContainer = button.closest(
                    `.${subnavListContainerClass}`
                );

                if (!subnavListContainer) {
                    return;
                }

                subnavListContainer.classList.remove(IS_OPEN);
                subnavListContainer.classList.remove(contentContainerClass);
            });
        });
    }

    /**
     * * @returns {void}
     */
    function removeSubnavHeightOnMouseleave() {
        subnavs.forEach(nav => {
            nav.addEventListener('mouseleave', event => {
                const { currentTarget } = event;

                currentTarget.removeAttribute('style');
            });
        });
    }
};

export default mainMenu;
